.base-card {
  box-shadow: var(--elevation-mid-h-offset) var(--elevation-mid-v-offset) var(--elevation-mid-blur) var(--color-elevation);
  transition: box-shadow 0.3s;
  background-color: var(--color-neutral-xxlight);
  color: var(--color-text-base);
  height: 100%;
  overflow-y: auto;
}

.top {
  position: sticky;
  top: 0;
  background-color: var(--color-neutral-xxlight);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row-reverse;
  z-index: 10;

  .close-button {
    margin-right: var(--spacing-sm);
  }
}

.container {
  display: flex;
  flex-direction: column;
  padding: 0 var(--spacing-sm) var(--spacing-sm) var(--spacing-sm);
}

::slotted([slot='image']) {
  display: block;
  overflow: hidden;
}

::slotted([slot='location']) {
  margin-bottom: var(--spacing-xs);
}
